import { render, staticRenderFns } from "./ArrivalDepartureDaysFormElement.vue?vue&type=template&id=23b9cb32&scoped=true&"
import script from "./ArrivalDepartureDaysFormElement.vue?vue&type=script&lang=js&"
export * from "./ArrivalDepartureDaysFormElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b9cb32",
  null
  
)

export default component.exports